
import { Vue, Component, Prop } from 'vue-property-decorator';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';
import ECommerceTableRow from '@/features/ecommerce/components/ECommerceTableRow.vue';
import { StoreForImport } from '@/features/shipment/types';

@Component({
  components: {
    DataTableWrapper,
    ECommerceTableRow,
  },
})
export default class ECommerceTable extends Vue {
  @Prop({ required: true }) connectedStores!: StoreForImport[];

  @Prop({ required: false, default: false }) loading!: boolean;
}
